// extracted by mini-css-extract-plugin
module.exports = {"root":"BackButton_root__33J9p","icon":"BackButton_icon__3kgXJ","button":"BackButton_button__2abAL"};